import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  carregando: {
    padding: theme.spacing(4),
    margin: '0 auto',
  },
  gridTitle: {
    borderBottom: 'thin solid #DDD',
    fontWeight: 600,
  },
  caracterRestantes: {
    display: 'block', marginTop: '4px' 
  },
}))

export default useStyles
